import { render, staticRenderFns } from "./distributeCourseList.vue?vue&type=template&id=2e691f0d&scoped=true"
import script from "./distributeCourseList.vue?vue&type=script&lang=js"
export * from "./distributeCourseList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e691f0d",
  null
  
)

export default component.exports